const SEND_NFT_INFO = 'index/SEND_NFT_INFO' as const;
const SET_SEND_NFT_INFO = 'index/SET_SEND_NFT_INFO' as const;

export const getSendNftInfo = () => ({
  type: SEND_NFT_INFO,
});

export const setSendNftInfo = (state: SendNftState) => ({
  type: SET_SEND_NFT_INFO,
  payload: state,
});

type SendAction = ReturnType<typeof getSendNftInfo> | ReturnType<typeof setSendNftInfo>;

export type SendNftState = {
  fromAddr: string | null;
  toAddr: string | null;
  contract: string | undefined;
  tokenId: string | null;
  tokenType: string;
};
const initialState: SendNftState = {
  fromAddr: null,
  toAddr: null,
  contract: undefined,
  tokenId: null,
  tokenType: '',
};

function sendNft(state: SendNftState = initialState, action: SendAction): any {
  switch (action.type) {
    case SEND_NFT_INFO:
      return { ...state };
    case SET_SEND_NFT_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default sendNft;
